import { FC } from 'react';
import { FooterButtons, ModalBoxRenderProps, ModalContainer, ModalContent, ModalHeader } from 'components/ModalBox';
import { useTranslationAPI } from '../../translations';
import PaddingBox from '../../../components/PaddingBox';
import Typography from '../../../components/Typography';
import FlexGrid from '../../../components/FlexGrid';
import CountdownSeconds from '../../../components/Countdown/CoundownSeconds';
import classes from './styles.module.css';
import { codes } from '../../../data/translations';
import { OUTDATED_APP_REFRESH_TIME } from './const';
import Button from '../../../components/Button';
import { useStyleContextState } from '../../styleContext';

type OutdatedAppWarnModalProps = {
	modalRenderProps: ModalBoxRenderProps;
	allowCloseModal: boolean;
};

const OutdatedAppWarnModal: FC<OutdatedAppWarnModalProps> = ({ modalRenderProps, allowCloseModal }) => {
	const { translate } = useTranslationAPI();
	const initialSeconds = Math.floor(OUTDATED_APP_REFRESH_TIME / 1000);
	const { cmsImagePathUrl } = useStyleContextState();
	const imageUrl = `${cmsImagePathUrl}ErrorPage/maintenance.png`;

	return (
		<ModalContainer>
			<ModalHeader
				{...modalRenderProps}
				title={translate(codes.outdatedApp.modalTitle)}
				hideCloseButton={!allowCloseModal}
				isLoading={!allowCloseModal}
			/>
			<ModalContent useContentHeight>
				<PaddingBox vrNormal>
					<FlexGrid
						column
						gap='small'
						center
					>
						<Typography
							display='block'
							fontSize={18}
							align='center'
						>
							{translate(codes.outdatedApp.applicationHasBeenUpdated)}
						</Typography>
						<div
							style={{
								height: '187px',
								width: '240px',
							}}
						>
							<img
								src={imageUrl}
								className={classes.image}
							/>
						</div>
						<Typography
							display='block'
							fontSize={18}
							align='center'
						>
							{translate(codes.outdatedApp.refreshTime)}
						</Typography>
						<CountdownSeconds initialSeconds={initialSeconds} />
					</FlexGrid>
				</PaddingBox>
			</ModalContent>
			{allowCloseModal && (
				<FooterButtons
					rightButtons={[
						<Button
							link
							onClick={modalRenderProps.onClose}
						>
							{translate(codes.common.cancel)}
						</Button>,
					]}
				/>
			)}
		</ModalContainer>
	);
};

export { OutdatedAppWarnModal };
